'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _auth = require('../actions/auth');

var defaultState = {
    isAuthenticated: false,
    requestingLogin: false,
    loginErrorMessage: '',
    userEmail: null
};

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];


    switch (action.type) {
        case _auth.actionTypes.LOGIN_REQUEST:
            return _extends({}, state, {
                requestingLogin: true
            });
        case _auth.actionTypes.LOGIN_SUCCESS:
            return _extends({}, state, {
                requestingLogin: false,
                isAuthenticated: true,
                userEmail: action.userEmail
            });
        case _auth.actionTypes.LOGIN_FAILED:
            return _extends({}, state, {
                requestingLogin: false,
                loginErrorMessage: action.errorMessage
            });
        case _auth.actionTypes.LOGOUT_SUCCESS:
            return _extends({}, state, {
                isAuthenticated: false
            });
        default:
            return state;
    }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvcmVkdWNlcnMvYXV0aC5qcyJdLCJuYW1lcyI6WyJkZWZhdWx0U3RhdGUiLCJpc0F1dGhlbnRpY2F0ZWQiLCJyZXF1ZXN0aW5nTG9naW4iLCJsb2dpbkVycm9yTWVzc2FnZSIsInVzZXJFbWFpbCIsInN0YXRlIiwiYWN0aW9uIiwidHlwZSIsImFjdGlvblR5cGVzIiwiTE9HSU5fUkVRVUVTVCIsIkxPR0lOX1NVQ0NFU1MiLCJMT0dJTl9GQUlMRUQiLCJlcnJvck1lc3NhZ2UiLCJMT0dPVVRfU1VDQ0VTUyJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7QUFBQTs7QUFFQSxJQUFNQSxlQUFlO0FBQ2pCQyxxQkFBaUIsS0FEQTtBQUVqQkMscUJBQWlCLEtBRkE7QUFHakJDLHVCQUFtQixFQUhGO0FBSWpCQyxlQUFXO0FBSk0sQ0FBckI7O2tCQU9lLFlBQWtDO0FBQUEsUUFBakNDLEtBQWlDLHVFQUF6QkwsWUFBeUI7QUFBQSxRQUFYTSxNQUFXOzs7QUFFN0MsWUFBUUEsT0FBT0MsSUFBZjtBQUNJLGFBQUtDLGtCQUFZQyxhQUFqQjtBQUNJLGdDQUNPSixLQURQO0FBRUlILGlDQUFpQjtBQUZyQjtBQUlKLGFBQUtNLGtCQUFZRSxhQUFqQjtBQUNJLGdDQUNPTCxLQURQO0FBRUlILGlDQUFpQixLQUZyQjtBQUdJRCxpQ0FBaUIsSUFIckI7QUFJSUcsMkJBQVdFLE9BQU9GO0FBSnRCO0FBTUosYUFBS0ksa0JBQVlHLFlBQWpCO0FBQ0ksZ0NBQ09OLEtBRFA7QUFFSUgsaUNBQWlCLEtBRnJCO0FBR0lDLG1DQUFtQkcsT0FBT007QUFIOUI7QUFLSixhQUFLSixrQkFBWUssY0FBakI7QUFDSSxnQ0FDT1IsS0FEUDtBQUVJSixpQ0FBaUI7QUFGckI7QUFJSjtBQUNJLG1CQUFPSSxLQUFQO0FBekJSO0FBMkJILEMiLCJmaWxlIjoiYXV0aC5qcyIsInNvdXJjZVJvb3QiOiIvc3JjIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgYWN0aW9uVHlwZXMgfSBmcm9tICcuLi9hY3Rpb25zL2F1dGgnO1xuXG5jb25zdCBkZWZhdWx0U3RhdGUgPSB7XG4gICAgaXNBdXRoZW50aWNhdGVkOiBmYWxzZSxcbiAgICByZXF1ZXN0aW5nTG9naW46IGZhbHNlLFxuICAgIGxvZ2luRXJyb3JNZXNzYWdlOiAnJyxcbiAgICB1c2VyRW1haWw6IG51bGxcbn07XG5cbmV4cG9ydCBkZWZhdWx0IChzdGF0ZSA9IGRlZmF1bHRTdGF0ZSwgYWN0aW9uKSA9PiB7XG5cbiAgICBzd2l0Y2ggKGFjdGlvbi50eXBlKSB7XG4gICAgICAgIGNhc2UgYWN0aW9uVHlwZXMuTE9HSU5fUkVRVUVTVDpcbiAgICAgICAgICAgIHJldHVybiB7XG4gICAgICAgICAgICAgICAgLi4uc3RhdGUsXG4gICAgICAgICAgICAgICAgcmVxdWVzdGluZ0xvZ2luOiB0cnVlXG4gICAgICAgICAgICB9O1xuICAgICAgICBjYXNlIGFjdGlvblR5cGVzLkxPR0lOX1NVQ0NFU1M6XG4gICAgICAgICAgICByZXR1cm4ge1xuICAgICAgICAgICAgICAgIC4uLnN0YXRlLFxuICAgICAgICAgICAgICAgIHJlcXVlc3RpbmdMb2dpbjogZmFsc2UsXG4gICAgICAgICAgICAgICAgaXNBdXRoZW50aWNhdGVkOiB0cnVlLFxuICAgICAgICAgICAgICAgIHVzZXJFbWFpbDogYWN0aW9uLnVzZXJFbWFpbFxuICAgICAgICAgICAgfTtcbiAgICAgICAgY2FzZSBhY3Rpb25UeXBlcy5MT0dJTl9GQUlMRUQ6XG4gICAgICAgICAgICByZXR1cm4ge1xuICAgICAgICAgICAgICAgIC4uLnN0YXRlLFxuICAgICAgICAgICAgICAgIHJlcXVlc3RpbmdMb2dpbjogZmFsc2UsXG4gICAgICAgICAgICAgICAgbG9naW5FcnJvck1lc3NhZ2U6IGFjdGlvbi5lcnJvck1lc3NhZ2VcbiAgICAgICAgICAgIH07XG4gICAgICAgIGNhc2UgYWN0aW9uVHlwZXMuTE9HT1VUX1NVQ0NFU1M6XG4gICAgICAgICAgICByZXR1cm4ge1xuICAgICAgICAgICAgICAgIC4uLnN0YXRlLFxuICAgICAgICAgICAgICAgIGlzQXV0aGVudGljYXRlZDogZmFsc2VcbiAgICAgICAgICAgIH07XG4gICAgICAgIGRlZmF1bHQ6XG4gICAgICAgICAgICByZXR1cm4gc3RhdGU7XG4gICAgfVxufTtcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./src/client/reducers/auth.js
// module id = 2247
// module chunks = 0